module.exports = __webpack_public_path__ + "img/Kerkira.34ee80c3.png";